import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import koKR from 'antd/locale/ko_KR';
import LoginPage from './pages/LoginPage';
import MainLayout from './components/MainLayout';
import ErrorBoundary from './components/ErrorBoundary';
import { PermissionProvider } from './contexts/PermissionContext';
import { getToken } from './services/authToken';
import { antdTheme } from './theme';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = getToken();
  return token ? <>{children}</> : <Navigate to="/login" />;
}

function App() {
  return (
    <ErrorBoundary>
      <ConfigProvider locale={koKR} theme={antdTheme}>
        <AntApp>
          <PermissionProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/*" element={
                  <PrivateRoute><MainLayout /></PrivateRoute>
                } />
              </Routes>
            </BrowserRouter>
          </PermissionProvider>
        </AntApp>
      </ConfigProvider>
    </ErrorBoundary>
  );
}

export default App;
